import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Stack,
} from '@chakra-ui/react';

interface Accordion1Props {
  //   title: string;
  Header: React.ReactNode;
  Panel: React.ReactNode;
}

export default function Accordion1({ Header, Panel }: Accordion1Props) {
  return (
    <Accordion rounded="2xl" allowToggle>
      <AccordionItem
        rounded="2xl"
        border="0px"
        background={'ButtonFace'}
        overflow="hidden"
      >
        <AccordionButton>
          {Header}
          {/* <Box as="span" flex="1" textAlign="left">
            {title}
          </Box> */}
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel>{Panel}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
